import AnalyticsView from 'views/Analytics/AnalyticsView';
import CouponsView from 'views/Coupons/CouponsView';
import PackageExplorerView from 'views/PackageExplorer/PackageExplorerView';
import SegmentsView from 'views/Segments/SegmentsView';
import TestAndReleaseView from 'views/TestAndRelease/TestAndReleaseView';

import { LevelSpecificRoute } from './types';
import { ERouteContext } from './types';
import { createStoreRoutes } from './utils/storeLevelRoutesUtil';

const projectLevelSpecificRoutes: LevelSpecificRoute[] = [
  { path: 'statistics', element: <AnalyticsView /> },
  { path: 'segments/*', element: <SegmentsView /> },
  { path: 'package-explorer/*', element: <PackageExplorerView /> },
  { path: 'test-and-release/*', element: <TestAndReleaseView /> },
  { path: 'coupons/*', element: <CouponsView /> }
];

const projectLevelRoutes = (defaultProjectPage: string) => (
  createStoreRoutes(
    'project/:publisherId',
    defaultProjectPage,
    ERouteContext.PROJECT,
    projectLevelSpecificRoutes
  )
);

export default projectLevelRoutes;
